export default {
  NETDB_API_BASE_URL: '/api/',
  NETDB_API_VERSION: '4.2',
  ENABLE_OIC: true,
  BUILD_ID: 'dd77afb2,Job ID 2603824@ci-netdb-1.scc.kit.edu kit-gitlab/scc-net/netvs dind enabled runner',
  COMMIT_SHORT_SHA: 'dd77afb2',
  JOB_ID: '2603824'
}
